import { useHosOperators, useResOperators } from '../../../hooks/useOperators';
import { useUser } from '../../../contexts/UserContext';
import { useAppView } from '../../../contexts/AppViewContext';
import { SectorPanel } from './SectorPanel';
import { AppViewOption } from './AppViewOption';
import { SectorToggle } from './SectorToggle';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export const OperatorOptions = ({
  onSelect,
  onClose,
}: {
  onSelect(item: { id: string; code: string; sector: OperatorType }): void;
  onClose(): void;
}) => {
  const hospitality = useHosOperators();
  const residential = useResOperators();
  const navigate = useNavigate();

  const user = useUser();
  const appView = useAppView();

  const canViewHos =
    user.permissions.canHos && (hospitality.data?.length ?? 0) > 0;

  const canViewRes =
    user.permissions.canRes && (residential.data?.length ?? 0) > 0;

  const canViewAll = canViewHos && canViewRes;

  const canResOpCreate =
    appView.pending.sector === 'Residential' &&
    user.permissions.canResOpCreate &&
    user.permissions.canResGlobalView;

  const isInternalUser =
    user.email && user.email.endsWith('tangerineglobal.com');

  const handleCreateOperator = () => {
    appView.changePendingView(
      {
        id: 'NDP',
        code: 'NDP',
        sector: 'Residential',
        type: 'NDP',
      },
      true
    );
    navigate('/createOperator');
    onClose();
  };

  return (
    <React.Fragment>
      {canViewAll && <SectorToggle />}
      {canResOpCreate && (
        <div className="w-full p-3 border-2 border-b-0 border-background-dark">
          <button
            className="tg-border-button text-xs w-full"
            onClick={handleCreateOperator}
            type="button"
          >
            Create Operator
          </button>
        </div>
      )}
      <SectorPanel id="Hospitality">
        {(hospitality.data ?? []).map((operator) => (
          <AppViewOption
            key={operator.id}
            onClick={() =>
              onSelect({
                id: operator.id.toString(),
                code: operator.code ?? '',
                sector: operator.type,
              })
            }
            selected={operator.id == (appView.pending.id ?? 0)}
          >
            <span className="text-left whitespace-nowrap text-ellipsis overflow-hidden w-full">
              {operator.name}
            </span>
            <span className="text-left opacity-70 text-xs">{operator.id}</span>
          </AppViewOption>
        ))}
      </SectorPanel>

      <SectorPanel id="Residential">
        {residential.data &&
          residential.data.map((operator) => (
            <AppViewOption
              key={operator.id}
              onClick={() =>
                onSelect({
                  id: operator.id.toString(),
                  code: operator.code ?? '',
                  sector: operator.type,
                })
              }
              selected={operator.id == (appView.pending.id ?? 0)}
            >
              <span className="text-left whitespace-nowrap text-ellipsis overflow-hidden w-full">
                {operator.name}
              </span>
              {isInternalUser && (
                <span className="text-left opacity-70 text-xs">
                  {operator.id}
                </span>
              )}
            </AppViewOption>
          ))}
      </SectorPanel>
    </React.Fragment>
  );
};
